import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: theme.design.radius.xl,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      gap: theme.design.space.sm,
    },

    "& .MuiDialog-paper": {
      overflowY: "initial",
    },
  },

  modalContent: {
    position: "relative",
    overflowY: "scroll",
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space["2xl"],
    padding: "48px 60px 48px 60px",
    minWidth: 320,
    backgroundSize: "auto 100%",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      padding: `${theme.design.space["3xl"]}px ${theme.design.space.lg}px`,
    },

    "& a": {
      color: theme.design.color.text.link,
      textDecoration: "none",
    },
  },

  sirenIcon: {
    width: theme.design.size.control.lg,
    height: theme.design.size.control.lg,
  },

  title: {
    fontSize: theme.design.typography.size.display,
  },

  description: {
    color: theme.design.color.text.secondary,
    fontSize: theme.design.typography.size.bodySmall,
    maxWidth: 400,
    textAlign: "center",
  },

  message: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.design.space.lg,
    border: "6px solid",
    borderColor: theme.design.color.border.default,
    padding: `${theme.design.space.lg}px ${theme.design.space.xl}px`,
    borderRadius: theme.design.radius.xl,
    fontSize: theme.design.typography.size.titleSmall,

    "& img": {
      width: theme.design.size.icon.lg,
      height: theme.design.size.icon.lg,
    },
  },

  countdown: {
    color: theme.design.color.text.secondary,
  },
}));

export default styles;
